// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2qmqf","row":"Node_row__3Z1U_","label":"Node_label__3deY3","footer":"Node_footer__OB8x2"};